
const especialidadeGridConfig = {
  idField: "idCancelamento",
  columns: [
    { header: "Descrição", field: "DESCRICAO" },
    { header: "Tempo", field: "TEMPO",
      formatter: (value) => value !== null && value !== undefined
          ? `${String(value)} Min` : "-"
    },
    {
      header: "Valor",field: "valor",
      formatter: (value) => value !== null && value !== undefined
          ? `R$ ${Number(value).toFixed(2)}` : "-"
    },
    { header: "Ativo", field: "ATIVO", 
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default especialidadeGridConfig;